"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _pointsMall = require("@/api/pointsMall");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var defaultObj = {
  id: 0,
  name: '',
  sort: 0,
  status: true,
  value: ''
};
var _default2 = exports.default = {
  name: 'creatSection',
  props: {
    editData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      loadingFrom: false,
      rules: {
        name: [{
          required: true,
          message: '请输入区间名称',
          trigger: 'blur'
        }],
        minNum: [{
          required: true,
          message: '必填项，请维护',
          trigger: 'blur'
        }, {
          validator: this.validateCom,
          trigger: 'blur'
        }, {
          validator: this.validateMin,
          trigger: 'blur'
        }],
        maxNum: [{
          required: true,
          message: '必填项，请维护',
          trigger: 'blur'
        }, {
          validator: this.validateCom,
          trigger: 'blur'
        }, {
          validator: this.validateMax,
          trigger: 'blur'
        }]
      },
      dataForm: _objectSpread({}, this.editData),
      minNum: 0,
      //最小值
      maxNum: 999999 //最大值
    };
  },
  watch: {
    editData: {
      handler: function handler(val) {
        this.dataForm = _objectSpread(_objectSpread({}, val), {}, {
          sort: val.sort ? val.sort : 0,
          minNum: val.value ? val.value.split('-')[0] : '',
          maxNum: val.value ? val.value.split('-')[1] : ''
        });
      },
      deep: true
    }
  },
  methods: {
    // 基础判断：1、输入值符合 0<num<100,且为正整数的规则
    validateCom: function validateCom(rule, value, callback) {
      var num = Number(value);
      if (Number.isInteger(num)) {
        if (num < this.minNum) {
          return callback(new Error('输入值必须大于0'));
        } else if (num > this.maxNum) {
          return callback(new Error('输入值必须小于999999'));
        }
        return callback();
      }
      return callback(new Error('输入值必须为正整数'));
    },
    // 最小值判断：不得大于最大值
    validateMin: function validateMin(rule, value, callback) {
      var num = Number(value);
      var max = Number(this.dataForm.maxNum);
      if (!max || num < max) {
        return callback();
      }
      return callback(new Error('输入值不得大于最大值'));
    },
    // 最小值判断：不得小于最小值
    validateMax: function validateMax(rule, value, callback) {
      var num = Number(value);
      var min = Number(this.dataForm.minNum);
      if (!min || num > min) {
        return callback();
      }
      return callback(new Error('输入值不得小于最小值'));
    },
    handleClose: function handleClose() {
      var _this = this;
      this.$refs['dataForm'].resetFields();
      this.$nextTick(function () {
        _this.dialogVisible = false;
      });
    },
    onClose: function onClose() {
      var _this2 = this;
      this.$refs['dataForm'].resetFields();
      this.$nextTick(function () {
        _this2.dialogVisible = false;
      });
      this.loading = false;
      this.$emit('getList');
    },
    onsubmit: function onsubmit(formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          _this3.dataForm.value = "".concat(_this3.dataForm.minNum, "-").concat(_this3.dataForm.maxNum);
          !_this3.dataForm.id ? (0, _pointsMall.intervalSaveApi)(_this3.dataForm).then(function (res) {
            _this3.$message.success('操作成功');
            _this3.onClose();
          }).catch(function () {
            _this3.loading = false;
          }) : (0, _pointsMall.intervalUpdateApi)(_this3.dataForm).then(function (res) {
            _this3.$message.success('操作成功');
            _this3.onClose();
          }).catch(function () {
            _this3.loading = false;
          });
        } else {
          return false;
        }
      });
    }
  }
};